import { Text, Tooltip } from "@wayflyer/flyui";
import { theme } from "@wayflyer/flyui-tokens";
import type { DataTableColumn } from "@wayflyer/flyui-dataviz";
import type { ReactNode } from "react";

import { MetricTypes } from "../../autogen/metrics";

export type LtvRow = Record<string, string | number>;
export const ltvBackgrounds = [
  theme.palette.dataviz.sequential.viridis["400"],
  theme.palette.dataviz.sequential.viridis["500"],
  theme.palette.dataviz.sequential.viridis["600"],
  theme.palette.dataviz.sequential.viridis["700"],
] as const;
export const belowCacBackground = theme.palette.dataviz.categorical.category4;

export const getLtvBand = (row: LtvRow, id: string, quartiles: number[]) => {
  const raw = row[`sort_${id}`];
  if (row[id] == null || raw == null || !Number.isFinite(Number(raw))) {
    return undefined;
  }
  const value = Number(raw);
  if (value <= Number(row[`sort_${MetricTypes.ALLTIME_CAC}`])) {
    return "belowCac";
  }
  return value < quartiles[1] ? 0 : value < quartiles[2] ? 1 : value < quartiles[3] ? 2 : 3;
};

export const getHeatmapColumn = (
  id: string,
  name: string,
  quartiles: number[],
  getTooltip: (row: LtvRow, id: string) => ReactNode
): DataTableColumn<LtvRow> => ({
  id,
  name,
  align: "center",
  cellAppearance: ({ row }) => {
    const band = getLtvBand(row.original, id, quartiles);
    return band === undefined
      ? undefined
      : { background: band === "belowCac" ? belowCacBackground : ltvBackgrounds[band], separator: "heatmap" };
  },
  render: ({ row }) => {
    const band = getLtvBand(row.original, id, quartiles);
    if (band === undefined) {
      return null;
    }
    const text = (
      <Text
        color={band === 3 ? "onDark" : "default"}
        fontWeight={row.original.fcp === "Average" ? "semiBold" : "regular"}
      >
        {row.original[id]}
      </Text>
    );
    const tooltip = getTooltip(row.original, id);
    return tooltip ? <Tooltip content={tooltip}>{text}</Tooltip> : text;
  },
});
